import Tippy from '@tippyjs/react';

import { cn, ia, iaRa } from 'lib/helpers/utility';

const chipBaseClass =
  'flex max-h-[20px] items-center rounded-[4px] border border-solid border-neutral-200 bg-neutral-100 p-1 text-xs text-neutral-900';

const OverflowChipList = ({
  items,
  emptyText,
  visibleCount = 1,
  chipClassName = 'min-w-0 max-w-[160px]',
  className,
  justify = 'center'
}) => {
  const finalItems = iaRa(items);

  if (!ia(finalItems)) {
    return emptyText ? <span className="text-xs text-neutral-500">{emptyText}</span> : null;
  }

  const safeVisibleCount = Math.max(1, visibleCount);
  const visible = finalItems.slice(0, safeVisibleCount);
  const rest = finalItems.slice(safeVisibleCount);

  return (
    <div
      className={cn(
        'flex flex-row flex-wrap items-center gap-1',
        justify === 'center' && 'justify-center',
        justify === 'start' && 'justify-start',
        className
      )}>
      {visible.map((item, index) => (
        <Tippy
          key={`${item}-${index}`}
          content={<span className="text-white">{item}</span>}
          theme="dark"
          appendTo={() => document.body}>
          <span className={cn(chipBaseClass, chipClassName)}>
            <span className="min-w-0 truncate">{item}</span>
          </span>
        </Tippy>
      ))}

      {ia(rest) && (
        <Tippy
          className="custom-tooltip tippy-dark !rounded-md"
          allowHTML
          interactive
          appendTo={() => document.body}
          offset={[0, 10]}
          content={
            <div className="flex-column p-2">
              {rest.map((item, index) => (
                <div key={`${item}-${index}`} className="text-slate-50 m-1 rounded-md p-1">
                  {item}
                </div>
              ))}
            </div>
          }>
          <span className={chipBaseClass}>+{rest.length}</span>
        </Tippy>
      )}
    </div>
  );
};

export default OverflowChipList;
